var toastr = require('toastr')
export default class FlashMessage {
  toastr_option() {
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": 0,
      "extendedTimeOut": 0,
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut",
      "tapToDismiss": false
    }

    toastr.options.onclick = function(e) {
      $.ajax({
        method: "patch",
        url: Routes.update_flash_message_status_company_user_flash_messages_path(gon.locale),
        data: {
          id: e.target.id,
          redirect: true,
        },
        success: function (res) {
          if(res.link) {
            window.location.href = res.link;
          }
        },
        fail: function (error) {
          console.log(error)
        }
      })
    }

    toastr.options.onCloseClick = function(e) {
      $.ajax({
        method: "patch",
        url: Routes.update_flash_message_status_company_user_flash_messages_path(gon.locale),
        data: {
          id: e.target.parentElement.lastChild.children[0].id
        }
      })
    }
  }
}
